import { FormlyFieldConfig } from '@ngx-formly/core';
import { environment as env } from 'environments/environment';

export const IntestatarioStep: FormlyFieldConfig[] = [
    {
        fieldGroupClassName:
            'border border-t-4 p-4 shadow-sm rounded-xl mt-3 mb-6 grid grid-flow-dense',
        fieldGroup: [
            {
                fieldGroupClassName:
                    'grid sm:grid-cols-1 md:grid-cols-12 gap-4',
                fieldGroup: [
                    {
                        className: 'sm:col-span-1 md:col-span-4',
                        key: 'intestatario.cognome',
                        type: 'mat-input',
                        props: {
                            label: 'COGNOME',
                            required: true,
                            uppercase: true,
                            spidlock: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-4',
                        key: 'intestatario.nome',
                        type: 'mat-input',
                        props: {
                            label: 'NOME',
                            required: true,
                            uppercase: true,
                            spidlock: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-4',
                        key: 'intestatario.cf',
                        type: '#cf',
                        props: {
                            spidlock: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.sesso',
                        type: 'mat-select',
                        props: {
                            label: 'SESSO',
                            options: [
                                { value: 'M', label: 'M' },
                                { value: 'F', label: 'F' },
                            ],
                            required: true,
                            spidlock: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.cittadinanza',
                        type: 'mat-select',
                        props: {
                            label: 'CITTADINANZA',
                            required: true,
                            options: [
                                { value: 1, label: 'ITALIANA' },
                                { value: 2, label: 'COMUNITARIO' },
                                { value: 3, label: 'EXTRACOMUNITARIO' },
                            ],
                            change: (field) => {
                                const opts = field.props.options as Array<{
                                    value: any;
                                    label: string;
                                }>;
                                const selected = opts.find(
                                    (o) => o.value === field.formControl.value,
                                );
                                field.form
                                    .get('intestatario.cittadinanza_value')
                                    ?.setValue(selected?.label ?? null);
                            },
                        },
                    },
                    { key: 'intestatario.cittadinanza_value' },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.comune_nato_dict',
                        type: '#autocomplete-comune',
                        props: {
                            label: 'COMUNE/STATO DI NASCITA',
                            required: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.data_nato',
                        type: '#data',
                        props: {
                            label: 'DATA DI NASCITA',
                            required: true,
                            startAt: new Date(1980, 0, 1),
                            spidlock: true,
                        },
                        expressions: {
                            'props.datepickerOptions.startAt': (field) => {
                                const model = field.model;
                                const d = model.intestatario?.data_nato;
                                return d ? new Date(d) : new Date(1980, 0, 1);
                            },
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.email',
                        type: '#email',
                        props: {
                            required: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.pec',
                        type: '#email',
                        props: {
                            label: 'PEC',
                        },
                        expressions: {
                            'props.required': () => env.comune == 'RAPALLO',
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.cellulare',
                        type: 'mat-input',
                        props: {
                            label: 'CELLULARE',
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.telefono',
                        type: 'mat-input',
                        props: {
                            label: 'TELEFONO',
                            required: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.comune_dict',
                        type: '#autocomplete-comune',
                        props: {
                            label: 'COMUNE DI RESIDENZA',
                            required: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.indirizzo',
                        type: 'mat-input',
                        props: {
                            label: 'INDIRIZZO DI RESIDENZA',
                            required: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.cap',
                        type: 'mat-input',
                        props: {
                            label: 'CAP',
                            required: true,
                            pattern: '^[0-9]{5}$',
                        },
                        validation: {
                            show: true,
                            messages: {
                                pattern:
                                    'Il CAP deve essere di 5 cifre numeriche',
                            },
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'intestatario.civico',
                        type: 'mat-input',
                        props: {
                            label: 'N° CIVICO',
                        },
                    },
                    {
                        key: 'intestatario.giuridica_opt',
                    },
                ],
            },
            {
                key: 'intestatario.domicilio_opt',
                type: 'mat-checkbox',
                defaultValue: false,
                props: {
                    label: 'DOMICILIO DIVERSO DA RESIDENZA',
                    indeterminate: false,
                    color: 'primary',
                },
            },
            {
                fieldGroupClassName: 'grid sm:grid-cols-1 md:grid-cols-4 gap-4',
                fieldGroup: [
                    {
                        className: 'sm:col-span-1 md:col-span-1',
                        key: 'intestatario.domicilio.comune_dict',
                        type: '#autocomplete-comune',
                        props: {
                            label: 'COMUNE',
                            required: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-1',
                        key: 'intestatario.domicilio.indirizzo',
                        type: 'mat-input',
                        props: {
                            label: 'INDIRIZZO',
                            required: true,
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-1',
                        key: 'intestatario.domicilio.cap',
                        type: 'mat-input',
                        props: {
                            label: 'CAP',
                            required: true,
                            pattern: '^[0-9]{5}$',
                        },
                        validation: {
                            messages: {
                                pattern:
                                    'Il CAP deve essere di 5 cifre numeriche',
                            },
                        },
                    },
                    {
                        className: 'sm:col-span-1 md:col-span-1',
                        key: 'intestatario.domicilio.civico',
                        type: 'mat-input',
                        props: {
                            label: 'N° CIVICO',
                        },
                    },
                ],
                expressions: {
                    hide: '!(model.intestatario?.domicilio_opt)',
                },
            },
        ],
    },
];
